import {Stack} from '@mui/material';
import {ItemTitle} from './ItemTitle';
import {useTranslation} from 'react-i18next';
import {TechnicalSupportIssueStatus} from '../types';
import NewTable from '@ui/NewTable/NewTable';
import {
    technicalSupportIssueStatusHistoryColumns,
    technicalSupportIssueStatusHistoryTableConfig,
} from './utils';
import {translateTableColumnsTitle} from 'utils/functions/table';

type TechnicalSupportIssueStatusHistoryProps = {
    histories: TechnicalSupportIssueStatus[];
};

export const TechnicalSupportIssueStatusHistory = ({
    histories,
}: TechnicalSupportIssueStatusHistoryProps) => {
    const {t} = useTranslation('administration');
    const columns = translateTableColumnsTitle(technicalSupportIssueStatusHistoryColumns, [
        'administration',
    ]);

    return (
        <Stack gap={1}>
            <ItemTitle title={t('technicalSupport.statusHistory')} />
            <NewTable
                tableConfig={technicalSupportIssueStatusHistoryTableConfig}
                rows={histories}
                columns={columns}
            />
        </Stack>
    );
};
